/**
 * (1) rawCountries: 코드 그룹 정보
 */

export const rawCountries  = [
    {
        "countryName" : "South Georgia and the South Sandwich Islands",
        "iso2" : "GS",
        "iso3" : "SGS",
        "callingCode" : "+500"
      }, 
      {
        "countryName" : "Grenada",
        "iso2" : "GD",
        "iso3" : "GRD",
        "callingCode" : "+1473"
      }, {
        "countryName" : "Confédération suisse",
        "iso2" : "CH",
        "iso3" : "CHE",
        "callingCode" : "+41"
      }, {
        "countryName" : "Republic of Sierra Leone",
        "iso2" : "SL",
        "iso3" : "SLE",
        "callingCode" : "+232"
      }, {
        "countryName" : "Magyarország",
        "iso2" : "HU",
        "iso3" : "HUN",
        "callingCode" : "+36"
      }, {
        "countryName" : "中華民國",
        "iso2" : "TW",
        "iso3" : "TWN",
        "callingCode" : "+886"
      }, {
        "countryName" : "Territoire des îles Wallis et Futuna",
        "iso2" : "WF",
        "iso3" : "WLF",
        "callingCode" : "+681"
      }, {
        "countryName" : "Barbados",
        "iso2" : "BB",
        "iso3" : "BRB",
        "callingCode" : "+1246"
      }, {
        "countryName" : "Pitcairn Group of Islands",
        "iso2" : "PN",
        "iso3" : "PCN",
        "callingCode" : "+64"
      }, {
        "countryName" : "République de Côte d'Ivoire",
        "iso2" : "CI",
        "iso3" : "CIV",
        "callingCode" : "+225"
      }, {
        "countryName" : "الجمهورية التونسية",
        "iso2" : "TN",
        "iso3" : "TUN",
        "callingCode" : "+216"
      }, {
        "countryName" : "Repubblica italiana",
        "iso2" : "IT",
        "iso3" : "ITA",
        "callingCode" : "+39"
      }, {
        "countryName" : "République du Bénin",
        "iso2" : "BJ",
        "iso3" : "BEN",
        "callingCode" : "+229"
      }, {
        "countryName" : "Republik Indonesia",
        "iso2" : "ID",
        "iso3" : "IDN",
        "callingCode" : "+62"
      }, {
        "countryName" : "República de Cabo Verde",
        "iso2" : "CV",
        "iso3" : "CPV",
        "callingCode" : "+238"
      }, {
        "countryName" : "Federation of Saint Christopher and Nevis",
        "iso2" : "KN",
        "iso3" : "KNA",
        "callingCode" : "+1869"
      }, {
        "countryName" : "ສາທາລະນະ ຊາທິປະໄຕ ຄົນລາວ ຂອງ",
        "iso2" : "LA",
        "iso3" : "LAO",
        "callingCode" : "+856"
      }, {
        "countryName" : "Bonaire, Sint Eustatius en Saba",
        "iso2" : "BQ",
        "iso3" : "BES",
        "callingCode" : "+599"
      }, {
        "countryName" : "Republic of Uganda",
        "iso2" : "UG",
        "iso3" : "UGA",
        "callingCode" : "+256"
      }, {
        "countryName" : "Principat d'Andorra",
        "iso2" : "AD",
        "iso3" : "AND",
        "callingCode" : "+376"
      }, {
        "countryName" : "République du Burundi",
        "iso2" : "BI",
        "iso3" : "BDI",
        "callingCode" : "+257"
      }, {
        "countryName" : "Republiek van Suid-Afrika",
        "iso2" : "ZA",
        "iso3" : "ZAF",
        "callingCode" : "+27"
      }, {
        "countryName" : "République française",
        "iso2" : "FR",
        "iso3" : "FRA",
        "callingCode" : "+33"
      }, {
        "countryName" : "الدولة ليبيا",
        "iso2" : "LY",
        "iso3" : "LBY",
        "callingCode" : "+218"
      }, {
        "countryName" : "Estados Unidos Mexicanos",
        "iso2" : "MX",
        "iso3" : "MEX",
        "callingCode" : "+52"
      }, {
        "countryName" : "République gabonaise",
        "iso2" : "GA",
        "iso3" : "GAB",
        "callingCode" : "+241"
      }, {
        "countryName" : "Commonwealth of the Northern Mariana Islands",
        "iso2" : "MP",
        "iso3" : "MNP",
        "callingCode" : "+1670"
      }, {
        "countryName" : "Република Северна Македонија",
        "iso2" : "MK",
        "iso3" : "MKD",
        "callingCode" : "+389"
      }, {
        "countryName" : "中华人民共和国",
        "iso2" : "CN",
        "iso3" : "CHN",
        "callingCode" : "+86"
      }, {
        "countryName" : "الجمهورية اليمنية",
        "iso2" : "YE",
        "iso3" : "YEM",
        "callingCode" : "+967"
      }, {
        "countryName" : "Collectivité de Saint-Barthélemy",
        "iso2" : "BL",
        "iso3" : "BLM",
        "callingCode" : "+590"
      }, {
        "countryName" : "Bailiwick of Guernsey",
        "iso2" : "GG",
        "iso3" : "GGY",
        "callingCode" : "+44"
      }, {
        "countryName" : "Solomon Islands",
        "iso2" : "SB",
        "iso3" : "SLB",
        "callingCode" : "+677"
      }, {
        "countryName" : "Svalbard og Jan Mayen",
        "iso2" : "SJ",
        "iso3" : "SJM",
        "callingCode" : "+4779"
      }, {
        "countryName" : "Færøerne",
        "iso2" : "FO",
        "iso3" : "FRO",
        "callingCode" : "+298"
      }, {
        "countryName" : "Республика Узбекистан",
        "iso2" : "UZ",
        "iso3" : "UZB",
        "callingCode" : "+998"
      }, {
        "countryName" : "جمهورية مصر العربية",
        "iso2" : "EG",
        "iso3" : "EGY",
        "callingCode" : "+20"
      }, {
        "countryName" : "République du Sénégal",
        "iso2" : "SN",
        "iso3" : "SEN",
        "callingCode" : "+221"
      }, {
        "countryName" : "ශ්‍රී ලංකා ප්‍රජාතාන්ත්‍රික සමාජවාදී ජනරජය",
        "iso2" : "LK",
        "iso3" : "LKA",
        "callingCode" : "+94"
      }, {
        "countryName" : "دولة فلسطين",
        "iso2" : "PS",
        "iso3" : "PSE",
        "callingCode" : "+970"
      }, {
        "countryName" : "বাংলাদেশ গণপ্রজাতন্ত্রী",
        "iso2" : "BD",
        "iso3" : "BGD",
        "callingCode" : "+880"
      }, {
        "countryName" : "Piruw Suyu",
        "iso2" : "PE",
        "iso3" : "PER",
        "callingCode" : "+51"
      }, {
        "countryName" : "Republic of Singapore",
        "iso2" : "SG",
        "iso3" : "SGP",
        "callingCode" : "+65"
      }, {
        "countryName" : "Türkiye Cumhuriyeti",
        "iso2" : "TR",
        "iso3" : "TUR",
        "callingCode" : "+90"
      }, {
        "countryName" : "جمهوری اسلامی افغانستان",
        "iso2" : "AF",
        "iso3" : "AFG",
        "callingCode" : "+93"
      }, {
        "countryName" : "Aruba",
        "iso2" : "AW",
        "iso3" : "ABW",
        "callingCode" : "+297"
      }, {
        "countryName" : "Cook Islands",
        "iso2" : "CK",
        "iso3" : "COK",
        "callingCode" : "+682"
      }, {
        "countryName" : "United Kingdom of Great Britain and Northern Ireland",
        "iso2" : "GB",
        "iso3" : "GBR",
        "callingCode" : "+44"
      }, {
        "countryName" : "Republic of Zambia",
        "iso2" : "ZM",
        "iso3" : "ZMB",
        "callingCode" : "+260"
      }, {
        "countryName" : "Suomen tasavalta",
        "iso2" : "FI",
        "iso3" : "FIN",
        "callingCode" : "+358"
      }, {
        "countryName" : "République du Niger",
        "iso2" : "NE",
        "iso3" : "NER",
        "callingCode" : "+227"
      }, {
        "countryName" : "Territory of Christmas Island",
        "iso2" : "CX",
        "iso3" : "CXR",
        "callingCode" : "+61"
      }, {
        "countryName" : "Tokelau",
        "iso2" : "TK",
        "iso3" : "TKL",
        "callingCode" : "+690"
      }, {
        "countryName" : "República da Guiné-Bissau",
        "iso2" : "GW",
        "iso3" : "GNB",
        "callingCode" : "+245"
      }, {
        "countryName" : "Azərbaycan Respublikası",
        "iso2" : "AZ",
        "iso3" : "AZE",
        "callingCode" : "+994"
      }, {
        "countryName" : "Ile de la Réunion",
        "iso2" : "RE",
        "iso3" : "REU",
        "callingCode" : "+262"
      }, {
        "countryName" : "جمهورية جيبوتي",
        "iso2" : "DJ",
        "iso3" : "DJI",
        "callingCode" : "+253"
      }, {
        "countryName" : "조선민주주의인민공화국",
        "iso2" : "KP",
        "iso3" : "PRK",
        "callingCode" : "+850"
      }, {
        "countryName" : "Republic of Mauritius",
        "iso2" : "MU",
        "iso3" : "MUS",
        "callingCode" : "+230"
      }, {
        "countryName" : "Montserrat",
        "iso2" : "MS",
        "iso3" : "MSR",
        "callingCode" : "+1664"
      }, {
        "countryName" : "Virgin Islands of the United States",
        "iso2" : "VI",
        "iso3" : "VIR",
        "callingCode" : "+1340"
      }, {
        "countryName" : "República de Colombia",
        "iso2" : "CO",
        "iso3" : "COL",
        "callingCode" : "+57"
      }, {
        "countryName" : "Ελληνική Δημοκρατία",
        "iso2" : "GR",
        "iso3" : "GRC",
        "callingCode" : "+30"
      }, {
        "countryName" : "Republika Hrvatska",
        "iso2" : "HR",
        "iso3" : "HRV",
        "callingCode" : "+385"
      }, {
        "countryName" : "المملكة المغربية",
        "iso2" : "MA",
        "iso3" : "MAR",
        "callingCode" : "+212"
      }, {
        "countryName" : "الجمهورية الديمقراطية الشعبية الجزائرية",
        "iso2" : "DZ",
        "iso3" : "DZA",
        "callingCode" : "+213"
      }, {
        "countryName" : "Koninkrijk der Nederlanden",
        "iso2" : "NL",
        "iso3" : "NLD",
        "callingCode" : "+31"
      }, {
        "countryName" : "جمهورية السودان",
        "iso2" : "SD",
        "iso3" : "SDN",
        "callingCode" : "+249"
      }, {
        "countryName" : "Republic of Fiji",
        "iso2" : "FJ",
        "iso3" : "FJI",
        "callingCode" : "+679"
      }, {
        "countryName" : "Fürstentum Liechtenstein",
        "iso2" : "LI",
        "iso3" : "LIE",
        "callingCode" : "+423"
      }, {
        "countryName" : "नेपाल संघीय लोकतान्त्रिक गणतन्त्र",
        "iso2" : "NP",
        "iso3" : "NPL",
        "callingCode" : "+977"
      }, {
        "countryName" : "Commonwealth of Puerto Rico",
        "iso2" : "PR",
        "iso3" : "PRI",
        "callingCode" : "+1787"
      }, {
        "countryName" : "საქართველო",
        "iso2" : "GE",
        "iso3" : "GEO",
        "callingCode" : "+995"
      }, {
        "countryName" : "Islamic Republic of Pakistan",
        "iso2" : "PK",
        "iso3" : "PAK",
        "callingCode" : "+92"
      }, {
        "countryName" : "Principauté de Monaco",
        "iso2" : "MC",
        "iso3" : "MCO",
        "callingCode" : "+377"
      }, {
        "countryName" : "Republic of Botswana",
        "iso2" : "BW",
        "iso3" : "BWA",
        "callingCode" : "+267"
      }, {
        "countryName" : "الجمهورية اللبنانية",
        "iso2" : "LB",
        "iso3" : "LBN",
        "callingCode" : "+961"
      }, {
        "countryName" : "Independent State of Papua New Guinea",
        "iso2" : "PG",
        "iso3" : "PNG",
        "callingCode" : "+675"
      }, {
        "countryName" : "Département de Mayotte",
        "iso2" : "YT",
        "iso3" : "MYT",
        "callingCode" : "+262"
      }, {
        "countryName" : "República Dominicana",
        "iso2" : "DO",
        "iso3" : "DOM",
        "callingCode" : "+1809"
      }, {
        "countryName" : "Territory of Norfolk Island",
        "iso2" : "NF",
        "iso3" : "NFK",
        "callingCode" : "+672"
      }, {
        "countryName" : "Bouvetøya",
        "iso2" : "BV",
        "iso3" : "BVT",
        "callingCode" : "+47"
      }, {
        "countryName" : "دولة قطر",
        "iso2" : "QA",
        "iso3" : "QAT",
        "callingCode" : "+974"
      }, {
        "countryName" : "République de Madagascar",
        "iso2" : "MG",
        "iso3" : "MDG",
        "callingCode" : "+261"
      }, {
        "countryName" : "Republic of India",
        "iso2" : "IN",
        "iso3" : "IND",
        "callingCode" : "+91"
      }, {
        "countryName" : "الجمهورية العربية السورية",
        "iso2" : "SY",
        "iso3" : "SYR",
        "callingCode" : "+963"
      }, {
        "countryName" : "Црна Гора",
        "iso2" : "ME",
        "iso3" : "MNE",
        "callingCode" : "+382"
      }, {
        "countryName" : "Kingdom of Eswatini",
        "iso2" : "SZ",
        "iso3" : "SWZ",
        "callingCode" : "+268"
      }, {
        "countryName" : "Tetã Paraguái",
        "iso2" : "PY",
        "iso3" : "PRY",
        "callingCode" : "+595"
      }, {
        "countryName" : "República de El Salvador",
        "iso2" : "SV",
        "iso3" : "SLV",
        "callingCode" : "+503"
      }, {
        "countryName" : "Україна",
        "iso2" : "UA",
        "iso3" : "UKR",
        "callingCode" : "+380"
      }, {
        "countryName" : "Isle of Man",
        "iso2" : "IM",
        "iso3" : "IMN",
        "callingCode" : "+44"
      }, {
        "countryName" : "Republiek van Namibië",
        "iso2" : "NA",
        "iso3" : "NAM",
        "callingCode" : "+264"
      }, {
        "countryName" : "الإمارات العربية المتحدة",
        "iso2" : "AE",
        "iso3" : "ARE",
        "callingCode" : "+971"
      }, {
        "countryName" : "Република България",
        "iso2" : "BG",
        "iso3" : "BGR",
        "callingCode" : "+359"
      }, {
        "countryName" : "Kalaallit Nunaat",
        "iso2" : "GL",
        "iso3" : "GRL",
        "callingCode" : "+299"
      }, {
        "countryName" : "Bundesrepublik Deutschland",
        "iso2" : "DE",
        "iso3" : "DEU",
        "callingCode" : "+49"
      }, {
        "countryName" : "ព្រះរាជាណាចក្រកម្ពុជា",
        "iso2" : "KH",
        "iso3" : "KHM",
        "callingCode" : "+855"
      }, {
        "countryName" : "جمهورية العراق",
        "iso2" : "IQ",
        "iso3" : "IRQ",
        "callingCode" : "+964"
      }, {
        "countryName" : "Territoire des Terres australes et antarctiques françaises",
        "iso2" : "TF",
        "iso3" : "ATF",
        "callingCode" : "+262"
      }, {
        "countryName" : "Konungariket Sverige",
        "iso2" : "SE",
        "iso3" : "SWE",
        "callingCode" : "+46"
      }, {
        "countryName" : "República de Cuba",
        "iso2" : "CU",
        "iso3" : "CUB",
        "callingCode" : "+53"
      }, {
        "countryName" : "Кыргыз Республикасы",
        "iso2" : "KG",
        "iso3" : "KGZ",
        "callingCode" : "+996"
      }, {
        "countryName" : "Российская Федерация",
        "iso2" : "RU",
        "iso3" : "RUS",
        "callingCode" : "+73"
      }, {
        "countryName" : "Malaysia",
        "iso2" : "MY",
        "iso3" : "MYS",
        "callingCode" : "+60"
      }, {
        "countryName" : "República Democrática do São Tomé e Príncipe",
        "iso2" : "ST",
        "iso3" : "STP",
        "callingCode" : "+239"
      }, {
        "countryName" : "Δημοκρατία της Κύπρος",
        "iso2" : "CY",
        "iso3" : "CYP",
        "callingCode" : "+357"
      }, {
        "countryName" : "Canada",
        "iso2" : "CA",
        "iso3" : "CAN",
        "callingCode" : "+1"
      }, {
        "countryName" : "Republic of Malawi",
        "iso2" : "MW",
        "iso3" : "MWI",
        "callingCode" : "+265"
      }, {
        "countryName" : "المملكة العربية السعودية",
        "iso2" : "SA",
        "iso3" : "SAU",
        "callingCode" : "+966"
      }, {
        "countryName" : "Bosna i Hercegovina",
        "iso2" : "BA",
        "iso3" : "BIH",
        "callingCode" : "+387"
      }, {
        "countryName" : "የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ",
        "iso2" : "ET",
        "iso3" : "ETH",
        "callingCode" : "+251"
      }, {
        "countryName" : "Reino de España",
        "iso2" : "ES",
        "iso3" : "ESP",
        "callingCode" : "+34"
      }, {
        "countryName" : "Republika Slovenija",
        "iso2" : "SI",
        "iso3" : "SVN",
        "callingCode" : "+386"
      }, {
        "countryName" : "سلطنة عمان",
        "iso2" : "OM",
        "iso3" : "OMN",
        "callingCode" : "+968"
      }, {
        "countryName" : "Collectivité territoriale de Saint-Pierre-et-Miquelon",
        "iso2" : "PM",
        "iso3" : "SPM",
        "callingCode" : "+508"
      }, {
        "countryName" : "Região Administrativa Especial de Macau da República Popular da China",
        "iso2" : "MO",
        "iso3" : "MAC",
        "callingCode" : "+853"
      }, {
        "countryName" : "Repubblica di San Marino",
        "iso2" : "SM",
        "iso3" : "SMR",
        "callingCode" : "+378"
      }, {
        "countryName" : "Kingdom of Lesotho",
        "iso2" : "LS",
        "iso3" : "LSO",
        "callingCode" : "+266"
      }, {
        "countryName" : "Republic of the Marshall Islands",
        "iso2" : "MH",
        "iso3" : "MHL",
        "callingCode" : "+692"
      }, {
        "countryName" : "Sint Maarten",
        "iso2" : "SX",
        "iso3" : "SXM",
        "callingCode" : "+1721"
      }, {
        "countryName" : "Ísland",
        "iso2" : "IS",
        "iso3" : "ISL",
        "callingCode" : "+354"
      }, {
        "countryName" : "Großherzogtum Luxemburg",
        "iso2" : "LU",
        "iso3" : "LUX",
        "callingCode" : "+352"
      }, {
        "countryName" : "Argentine Republic",
        "iso2" : "AR",
        "iso3" : "ARG",
        "callingCode" : "+54"
      }, {
        "countryName" : "Turks and Caicos Islands",
        "iso2" : "TC",
        "iso3" : "TCA",
        "callingCode" : "+1649"
      }, {
        "countryName" : "Republic of Nauru",
        "iso2" : "NR",
        "iso3" : "NRU",
        "callingCode" : "+674"
      }, {
        "countryName" : "Territory of the Cocos (Keeling) Islands",
        "iso2" : "CC",
        "iso3" : "CCK",
        "callingCode" : "+61"
      }, {
        "countryName" : "Sahrawi Arab Democratic Republic",
        "iso2" : "EH",
        "iso3" : "ESH",
        "callingCode" : "+2125288"
      }, {
        "countryName" : "Commonwealth of Dominica",
        "iso2" : "DM",
        "iso3" : "DMA",
        "callingCode" : "+1767"
      }, {
        "countryName" : "República de Costa Rica",
        "iso2" : "CR",
        "iso3" : "CRI",
        "callingCode" : "+506"
      }, {
        "countryName" : "Commonwealth of Australia",
        "iso2" : "AU",
        "iso3" : "AUS",
        "callingCode" : "+61"
      }, {
        "countryName" : "ราชอาณาจักรไทย",
        "iso2" : "TH",
        "iso3" : "THA",
        "callingCode" : "+66"
      }, {
        "countryName" : "République d'Haïti",
        "iso2" : "HT",
        "iso3" : "HTI",
        "callingCode" : "+509"
      }, {
        "countryName" : "Tuvalu",
        "iso2" : "TV",
        "iso3" : "TUV",
        "callingCode" : "+688"
      }, {
        "countryName" : "República de Honduras",
        "iso2" : "HN",
        "iso3" : "HND",
        "callingCode" : "+504"
      }, {
        "countryName" : "République de la Guinée Équatoriale",
        "iso2" : "GQ",
        "iso3" : "GNQ",
        "callingCode" : "+240"
      }, {
        "countryName" : "Saint Lucia",
        "iso2" : "LC",
        "iso3" : "LCA",
        "callingCode" : "+1758"
      }, {
        "countryName" : "Polynésie française",
        "iso2" : "PF",
        "iso3" : "PYF",
        "callingCode" : "+689"
      }, {
        "countryName" : "Рэспубліка Беларусь",
        "iso2" : "BY",
        "iso3" : "BLR",
        "callingCode" : "+375"
      }, {
        "countryName" : "Latvijas Republikas",
        "iso2" : "LV",
        "iso3" : "LVA",
        "callingCode" : "+371"
      }, {
        "countryName" : "Republic of Palau",
        "iso2" : "PW",
        "iso3" : "PLW",
        "callingCode" : "+680"
      }, {
        "countryName" : "Guadeloupe",
        "iso2" : "GP",
        "iso3" : "GLP",
        "callingCode" : "+590"
      }, {
        "countryName" : "Republic of the Philippines",
        "iso2" : "PH",
        "iso3" : "PHL",
        "callingCode" : "+63"
      }, {
        "countryName" : "Gibraltar",
        "iso2" : "GI",
        "iso3" : "GIB",
        "callingCode" : "+350"
      }, {
        "countryName" : "Kongeriget Danmark",
        "iso2" : "DK",
        "iso3" : "DNK",
        "callingCode" : "+45"
      }, {
        "countryName" : "Republic of Cameroon",
        "iso2" : "CM",
        "iso3" : "CMR",
        "callingCode" : "+237"
      }, {
        "countryName" : "République de Guinée",
        "iso2" : "GN",
        "iso3" : "GIN",
        "callingCode" : "+224"
      }, {
        "countryName" : "مملكة البحرين",
        "iso2" : "BH",
        "iso3" : "BHR",
        "callingCode" : "+973"
      }, {
        "countryName" : "Republiek Suriname",
        "iso2" : "SR",
        "iso3" : "SUR",
        "callingCode" : "+597"
      }, {
        "countryName" : "République démocratique du Congo",
        "iso2" : "CD",
        "iso3" : "COD",
        "callingCode" : "+243"
      }, {
        "countryName" : "جمهورية الصومال‎‎",
        "iso2" : "SO",
        "iso3" : "SOM",
        "callingCode" : "+252"
      }, {
        "countryName" : "Česká republika",
        "iso2" : "CZ",
        "iso3" : "CZE",
        "callingCode" : "+420"
      }, {
        "countryName" : "Nouvelle-Calédonie",
        "iso2" : "NC",
        "iso3" : "NCL",
        "callingCode" : "+687"
      }, {
        "countryName" : "Ripablik blong Vanuatu",
        "iso2" : "VU",
        "iso3" : "VUT",
        "callingCode" : "+678"
      }, {
        "countryName" : "Saint Helena, Ascension and Tristan da Cunha",
        "iso2" : "SH",
        "iso3" : "SHN",
        "callingCode" : "+290"
      }, {
        "countryName" : "République togolaise",
        "iso2" : "TG",
        "iso3" : "TGO",
        "callingCode" : "+228"
      }, {
        "countryName" : "Virgin Islands",
        "iso2" : "VG",
        "iso3" : "VGB",
        "callingCode" : "+1284"
      }, {
        "countryName" : "Republic of Kenya",
        "iso2" : "KE",
        "iso3" : "KEN",
        "callingCode" : "+254"
      }, {
        "countryName" : "Niue",
        "iso2" : "NU",
        "iso3" : "NIU",
        "callingCode" : "+683"
      }, {
        "countryName" : "Republic of Rwanda",
        "iso2" : "RW",
        "iso3" : "RWA",
        "callingCode" : "+250"
      }, {
        "countryName" : "Eesti Vabariik",
        "iso2" : "EE",
        "iso3" : "EST",
        "callingCode" : "+372"
      }, {
        "countryName" : "România",
        "iso2" : "RO",
        "iso3" : "ROU",
        "callingCode" : "+40"
      }, {
        "countryName" : "Republic of Trinidad and Tobago",
        "iso2" : "TT",
        "iso3" : "TTO",
        "callingCode" : "+1868"
      }, {
        "countryName" : "Co-operative Republic of Guyana",
        "iso2" : "GY",
        "iso3" : "GUY",
        "callingCode" : "+592"
      }, {
        "countryName" : "República Democrática de Timor-Leste",
        "iso2" : "TL",
        "iso3" : "TLS",
        "callingCode" : "+670"
      }, {
        "countryName" : "Cộng hòa xã hội chủ nghĩa Việt Nam",
        "iso2" : "VN",
        "iso3" : "VNM",
        "callingCode" : "+84"
      }, {
        "countryName" : "República Oriental del Uruguay",
        "iso2" : "UY",
        "iso3" : "URY",
        "callingCode" : "+598"
      }, {
        "countryName" : "Stato della Città del Vaticano",
        "iso2" : "VA",
        "iso3" : "VAT",
        "callingCode" : "+3906698"
      }, {
        "countryName" : "Hong Kong Special Administrative Region of the People's Republic of China",
        "iso2" : "HK",
        "iso3" : "HKG",
        "callingCode" : "+852"
      }, {
        "countryName" : "Republik Österreich",
        "iso2" : "AT",
        "iso3" : "AUT",
        "callingCode" : "+43"
      }, {
        "countryName" : "Antigua and Barbuda",
        "iso2" : "AG",
        "iso3" : "ATG",
        "callingCode" : "+1268"
      }, {
        "countryName" : "Туркменистан",
        "iso2" : "TM",
        "iso3" : "TKM",
        "callingCode" : "+993"
      }, {
        "countryName" : "República de Moçambique",
        "iso2" : "MZ",
        "iso3" : "MOZ",
        "callingCode" : "+258"
      }, {
        "countryName" : "República de Panamá",
        "iso2" : "PA",
        "iso3" : "PAN",
        "callingCode" : "+507"
      }, {
        "countryName" : "Federated States of Micronesia",
        "iso2" : "FM",
        "iso3" : "FSM",
        "callingCode" : "+691"
      }, {
        "countryName" : "Republic of Ireland",
        "iso2" : "IE",
        "iso3" : "IRL",
        "callingCode" : "+353"
      }, {
        "countryName" : "Country of Curaçao",
        "iso2" : "CW",
        "iso3" : "CUW",
        "callingCode" : "+599"
      }, {
        "countryName" : "Guyane",
        "iso2" : "GF",
        "iso3" : "GUF",
        "callingCode" : "+594"
      }, {
        "countryName" : "Kongeriket Noreg",
        "iso2" : "NO",
        "iso3" : "NOR",
        "callingCode" : "+47"
      }, {
        "countryName" : "Landskapet Åland",
        "iso2" : "AX",
        "iso3" : "ALA",
        "callingCode" : "+35818"
      }, {
        "countryName" : "République centrafricaine",
        "iso2" : "CF",
        "iso3" : "CAF",
        "callingCode" : "+236"
      }, {
        "countryName" : "République du Burkina",
        "iso2" : "BF",
        "iso3" : "BFA",
        "callingCode" : "+226"
      }, {
        "countryName" : "دولة إرتريا",
        "iso2" : "ER",
        "iso3" : "ERI",
        "callingCode" : "+291"
      }, {
        "countryName" : "United Republic of Tanzania",
        "iso2" : "TZ",
        "iso3" : "TZA",
        "callingCode" : "+255"
      }, {
        "countryName" : "대한민국",
        "iso2" : "KR",
        "iso3" : "KOR",
        "callingCode" : "+82"
      }, {
        "countryName" : "المملكة الأردنية الهاشمية",
        "iso2" : "JO",
        "iso3" : "JOR",
        "callingCode" : "+962"
      }, {
        "countryName" : "الجمهورية الإسلامية الموريتانية",
        "iso2" : "MR",
        "iso3" : "MRT",
        "callingCode" : "+222"
      }, {
        "countryName" : "Lietuvos Respublikos",
        "iso2" : "LT",
        "iso3" : "LTU",
        "callingCode" : "+370"
      }, {
        "countryName" : "United States Minor Outlying Islands",
        "iso2" : "UM",
        "iso3" : "UMI",
        "callingCode" : "+268"
      }, {
        "countryName" : "Slovenská republika",
        "iso2" : "SK",
        "iso3" : "SVK",
        "callingCode" : "+421"
      }, {
        "countryName" : "República de Angola",
        "iso2" : "AO",
        "iso3" : "AGO",
        "callingCode" : "+244"
      }, {
        "countryName" : "Қазақстан Республикасы",
        "iso2" : "KZ",
        "iso3" : "KAZ",
        "callingCode" : "+76"
      }, {
        "countryName" : "Republica Moldova",
        "iso2" : "MD",
        "iso3" : "MDA",
        "callingCode" : "+373"
      }, {
        "countryName" : "République du Mali",
        "iso2" : "ML",
        "iso3" : "MLI",
        "callingCode" : "+223"
      }, {
        "countryName" : "Falkland Islands",
        "iso2" : "FK",
        "iso3" : "FLK",
        "callingCode" : "+500"
      }, {
        "countryName" : "Հայաստանի Հանրապետություն",
        "iso2" : "AM",
        "iso3" : "ARM",
        "callingCode" : "+374"
      }, {
        "countryName" : "Independent State of Samoa",
        "iso2" : "WS",
        "iso3" : "WSM",
        "callingCode" : "+685"
      }, {
        "countryName" : "Bailiwick of Jersey",
        "iso2" : "JE",
        "iso3" : "JEY",
        "callingCode" : "+44"
      }, {
        "countryName" : "日本",
        "iso2" : "JP",
        "iso3" : "JPN",
        "callingCode" : "+81"
      }, {
        "countryName" : "Wuliwya Suyu",
        "iso2" : "BO",
        "iso3" : "BOL",
        "callingCode" : "+591"
      }, {
        "countryName" : "República de Chile",
        "iso2" : "CL",
        "iso3" : "CHL",
        "callingCode" : "+56"
      }, {
        "countryName" : "United States of America",
        "iso2" : "US",
        "iso3" : "USA",
        "callingCode" : "+1201"
      }, {
        "countryName" : "Saint Vincent and the Grenadines",
        "iso2" : "VC",
        "iso3" : "VCT",
        "callingCode" : "+1784"
      }, {
        "countryName" : "Bermuda",
        "iso2" : "BM",
        "iso3" : "BMU",
        "callingCode" : "+1441"
      }, {
        "countryName" : "Repiblik Sesel",
        "iso2" : "SC",
        "iso3" : "SYC",
        "callingCode" : "+248"
      }, {
        "countryName" : "British Indian Ocean Territory",
        "iso2" : "IO",
        "iso3" : "IOT",
        "callingCode" : "+246"
      }, {
        "countryName" : "República de Guatemala",
        "iso2" : "GT",
        "iso3" : "GTM",
        "callingCode" : "+502"
      }, {
        "countryName" : "República del Ecuador",
        "iso2" : "EC",
        "iso3" : "ECU",
        "callingCode" : "+593"
      }, {
        "countryName" : "Martinique",
        "iso2" : "MQ",
        "iso3" : "MTQ",
        "callingCode" : "+596"
      }, {
        "countryName" : "Республика Таджикистан",
        "iso2" : "TJ",
        "iso3" : "TJK",
        "callingCode" : "+992"
      }, {
        "countryName" : "Republic of Malta",
        "iso2" : "MT",
        "iso3" : "MLT",
        "callingCode" : "+356"
      }, {
        "countryName" : "Republic of the Gambia",
        "iso2" : "GM",
        "iso3" : "GMB",
        "callingCode" : "+220"
      }, {
        "countryName" : "Federal Republic of Nigeria",
        "iso2" : "NG",
        "iso3" : "NGA",
        "callingCode" : "+234"
      }, {
        "countryName" : "Commonwealth of the Bahamas",
        "iso2" : "BS",
        "iso3" : "BHS",
        "callingCode" : "+1242"
      }, {
        "countryName" : "Republika e Kosovës",
        "iso2" : "XK",
        "iso3" : "UNK",
        "callingCode" : "+383"
      }, {
        "countryName" : "دولة الكويت",
        "iso2" : "KW",
        "iso3" : "KWT",
        "callingCode" : "+965"
      }, {
        "countryName" : "ދިވެހިރާއްޖޭގެ ޖުމްހޫރިއްޔާ",
        "iso2" : "MV",
        "iso3" : "MDV",
        "callingCode" : "+960"
      }, {
        "countryName" : "Republic of South Sudan",
        "iso2" : "SS",
        "iso3" : "SSD",
        "callingCode" : "+211"
      }, {
        "countryName" : "جمهوری اسلامی ایران",
        "iso2" : "IR",
        "iso3" : "IRN",
        "callingCode" : "+98"
      }, {
        "countryName" : "Republika e Shqipërisë",
        "iso2" : "AL",
        "iso3" : "ALB",
        "callingCode" : "+355"
      }, {
        "countryName" : "República Federativa do Brasil",
        "iso2" : "BR",
        "iso3" : "BRA",
        "callingCode" : "+55"
      }, {
        "countryName" : "Република Србија",
        "iso2" : "RS",
        "iso3" : "SRB",
        "callingCode" : "+381"
      }, {
        "countryName" : "Belize",
        "iso2" : "BZ",
        "iso3" : "BLZ",
        "callingCode" : "+501"
      }, {
        "countryName" : "ပြည်ထောင်စု သမ္မတ မြန်မာနိုင်ငံတော်",
        "iso2" : "MM",
        "iso3" : "MMR",
        "callingCode" : "+95"
      }, {
        "countryName" : "འབྲུག་རྒྱལ་ཁབ་",
        "iso2" : "BT",
        "iso3" : "BTN",
        "callingCode" : "+975"
      }, {
        "countryName" : "República Bolivariana de Venezuela",
        "iso2" : "VE",
        "iso3" : "VEN",
        "callingCode" : "+58"
      }, {
        "countryName" : "Republic of Liberia",
        "iso2" : "LR",
        "iso3" : "LBR",
        "callingCode" : "+231"
      }, {
        "countryName" : "Jamaica",
        "iso2" : "JM",
        "iso3" : "JAM",
        "callingCode" : "+1876"
      }, {
        "countryName" : "Rzeczpospolita Polska",
        "iso2" : "PL",
        "iso3" : "POL",
        "callingCode" : "+48"
      }, {
        "countryName" : "Cayman Islands",
        "iso2" : "KY",
        "iso3" : "CYM",
        "callingCode" : "+1345"
      }, {
        "countryName" : "Nation of Brunei, Abode Damai",
        "iso2" : "BN",
        "iso3" : "BRN",
        "callingCode" : "+673"
      }, {
        "countryName" : "الاتحاد القمري",
        "iso2" : "KM",
        "iso3" : "COM",
        "callingCode" : "+269"
      }, {
        "countryName" : "Guåhån",
        "iso2" : "GU",
        "iso3" : "GUM",
        "callingCode" : "+1671"
      }, {
        "countryName" : "Kingdom of Tonga",
        "iso2" : "TO",
        "iso3" : "TON",
        "callingCode" : "+676"
      }, {
        "countryName" : "Independent and Sovereign Republic of Kiribati",
        "iso2" : "KI",
        "iso3" : "KIR",
        "callingCode" : "+686"
      }, {
        "countryName" : "Republic of Ghana",
        "iso2" : "GH",
        "iso3" : "GHA",
        "callingCode" : "+233"
      }, {
        "countryName" : "جمهورية تشاد",
        "iso2" : "TD",
        "iso3" : "TCD",
        "callingCode" : "+235"
      }, {
        "countryName" : "Republic of Zimbabwe",
        "iso2" : "ZW",
        "iso3" : "ZWE",
        "callingCode" : "+263"
      }, {
        "countryName" : "Saint-Martin",
        "iso2" : "MF",
        "iso3" : "MAF",
        "callingCode" : "+590"
      }, {
        "countryName" : "Монгол улс",
        "iso2" : "MN",
        "iso3" : "MNG",
        "callingCode" : "+976"
      }, {
        "countryName" : "República português",
        "iso2" : "PT",
        "iso3" : "PRT",
        "callingCode" : "+351"
      }, {
        "countryName" : "American Samoa",
        "iso2" : "AS",
        "iso3" : "ASM",
        "callingCode" : "+1684"
      }, {
        "countryName" : "République du Congo",
        "iso2" : "CG",
        "iso3" : "COG",
        "callingCode" : "+242"
      }, {
        "countryName" : "Königreich Belgien",
        "iso2" : "BE",
        "iso3" : "BEL",
        "callingCode" : "+32"
      }, {
        "countryName" : "دولة إسرائيل",
        "iso2" : "IL",
        "iso3" : "ISR",
        "callingCode" : "+972"
      }, {
        "countryName" : "New Zealand",
        "iso2" : "NZ",
        "iso3" : "NZL",
        "callingCode" : "+64"
      }, {
        "countryName" : "República de Nicaragua",
        "iso2" : "NI",
        "iso3" : "NIC",
        "callingCode" : "+505"
      }, {
        "countryName" : "Anguilla",
        "iso2" : "AI",
        "iso3" : "AIA",
        "callingCode" : "+1264"
      }
    ]